import { FC, useMemo } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router'
import PreConListing from './PreConListing'
import ProListing from './ProListing'
import ProListingProvider from '../provider/ProListingProvider'
import BrokerageListing from './BrokerageListing'

export const PropertyRoutes: FC = () => {
 const { pathname } = useLocation()

 const lType = useMemo(() => {
  if (pathname?.split('/')?.at(-1) === 'pre-con-listing') {
   return 'preconstruction'
  }
  if (pathname?.split('/')?.at(-1) === 'brokerage-listing') {
   return 'brokerage'
  }
  return 'listing'
 }, [pathname])

 return (
  <ProListingProvider
   from={
    pathname?.split('/')?.at(-1) === 'pre-con-listing'
     ? 'preconstruction'
     : 'listing'
   }
   lType={lType}
  >
   <Routes>
    <Route path="" element={<Navigate to="property-listing" />} />
    <Route path="property-listing" element={<ProListing />} />
    <Route path="pre-con-listing" element={<PreConListing />} />
    <Route path="brokerage-listing" element={<BrokerageListing />} />
   </Routes>
  </ProListingProvider>
 )
}
